var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('a',{attrs:{"href":"https://miltondavid.com","target":"_blank","rel":"noopener"}},[_vm._v(" miltondavid.com ")]),_c('p',[_vm._v("minhamola @ 2021 - "+_vm._s(_vm.currentYear))])])}
var staticRenderFns = []

export { render, staticRenderFns }